import { UpdateRecommendation } from 'domain/usecases/doctor/update-recommendation'
import { DeleteDoctorDocument } from 'domain/usecases/document/delete-doctor-document'
import { DocumentRepository } from 'repository/interfaces/document-repository'

export class RemoteDeleteDoctorDocument implements DeleteDoctorDocument {
  private readonly documentRepository: DocumentRepository

  constructor(documentRepository: DocumentRepository) {
    this.documentRepository = documentRepository
  }

  async delete(
    params: DeleteDoctorDocument.Params
  ): Promise<DeleteDoctorDocument.Model> {
    await this.documentRepository.deleteDoctorDocument(params)
  }
}

export type UpdateRecommendationModel = UpdateRecommendation.Model
